import React from "react";

export default function Step7() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          7
        </div>
        <h1 className="">
          Abra o e-mail e clique em <b>VERIFICAR E-MAIL</b>. <br /> Pronto,
          agora seu e-mail está verificado.
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px] flex items-start gap-5 flex-wrap">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3611.jpg?alt=media&token=9ae2e08a-b3b4-4b9a-9305-d80401d80657"
          className="w-72"
          alt=""
        />
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3612.jpg?alt=media&token=210c4213-a992-4755-b858-810fdc3bda46"
          className="hidden sm:block w-72"
          alt=""
        />
      </div>
    </div>
  );
}
